import React from "react";
import { styled } from "@material-ui/styles";
import { injectIntl } from "react-intl";
import Link from "../link";
import UserAvatar from "../user-avatar";
import { IUser } from "../../types";
import { IStyledArguments } from "../../types/styled-arguments";
import messages from "./PageDashboard.intl";

const Row = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
});

const Name = styled("div")(({ theme }: IStyledArguments) => ({
  fontFamily: theme.typography.alternateFontFamily,
  fontWeight: 700,
  fontSize: "1.35rem",
  color: theme.palette.text.primary,
}));

const Subtitle = styled("div")(({ theme }: IStyledArguments) => ({
  fontSize: "0.8rem",
  color: theme.palette.text.secondary,
  marginTop: 2,
}));

const AvatarLink = styled(Link)(({ theme }: IStyledArguments) => ({
  display: "block",
  width: 40,
  height: 40,
  "& > *": {
    width: "100%",
    height: "100%",
  },
}));

interface IGreetingHeader {
  user: IUser;
  subtitle?: string;
}

const GreetingHeader = injectIntl<IGreetingHeader>(({ user, subtitle, intl }) => (
  <Row>
    <div>
      <Name>{intl.formatMessage(messages.greeting, { name: user.name })}</Name>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </div>
    <AvatarLink to="/profile">
      <UserAvatar user={user} />
    </AvatarLink>
  </Row>
));

export default GreetingHeader;
